// @file Entrypoint for surface trashed view
import window from 'bits/global'
import { setupVueApp } from 'bits/vue'
import { useSurfaceTrashedViewStore } from 'pinia/surface_trashed_view'
import SurfaceTrashed from 'vuecomponents/SurfaceTrashed.vue'

void setupVueApp({
  el: '#surface_trashed',
  rootComponent: SurfaceTrashed,
  usePinia: true,
}).then((vueInstance) => {
  window.app = vueInstance
  useSurfaceTrashedViewStore().initializeState(window.ww.vueStartingState)
})
